import { Component, input, OnInit } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'mglsk-breadcrumb',
    imports: [BreadcrumbModule],
    templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {
  items = input<MenuItem[]>([]);
  home = input<MenuItem | undefined>();
}
